import React, { Component } from "react";
import { records, filter } from "../../../services/employerApplicant";
import List from "./List";
import AppContext from "../../../contexts/AppContext";

export class WorkSpaceFreelancers extends Component {
    state = {
        items: [],
        meta: {},
        query: "",
        filter: false,
        search: false,
        loading: true,
        tableCount: "hide",
        filterItem: "all"
    };

    filter = item => {
        this.setState({ loading: true });
        filter(this.props.job.id, item).then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                filter: true,
                loading: false,
                filterItem: item
            });
        });
    };
    clear = () => {
        this.setState({ loading: true });
        records(this.props.job.id, 1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    search: false,
                    filter: false,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };

    componentDidMount() {
        this.clear();
    }
    render() {
        return (
            <div className="container employer-container tab-content" id="myTabContent">
                <div
                    className="card tab-pane fade active show"
                    id="free"
                    role="tabpanel"
                    aria-labelledby="free-tab"
                >
                    <div className="card-header">
                        <div className="row align-items-center">
                            <div className="col">
                                <h4 className="card-header-title">
                                    Freelancers
                                </h4>
                            </div>
                        </div>
                    </div>
                    {window.location.pathname ===
                    "/employer/jobListing/workSpace/" +
                        this.props.match.params["link"] ? (
                        <div className="card-body">
                            <div className="row align-items-center mb-3">
                                <div className="col">
                                    <ul className="nav nav-tabs nav-overflow header-tabs">
                                        <li className="nav-item">
                                            <button
                                                onClick={() =>
                                                    this.filter("all")
                                                }
                                                className={
                                                    this.state.filterItem ===
                                                    "all"
                                                        ? `nav-link active`
                                                        : `nav-link `
                                                }
                                            >
                                                All{" "}
                                                <span className="badge badge-pill badge-soft-secondary">
                                                    {this.state.meta.total}
                                                </span>
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                onClick={() =>
                                                    this.filter("applied")
                                                }
                                                className={
                                                    this.state.filterItem ===
                                                    "applied"
                                                        ? `nav-link active`
                                                        : `nav-link`
                                                }
                                            >
                                                Applied{" "}
                                                <span className="badge badge-pill badge-soft-secondary">
                                                    {this.state.meta.applied}
                                                </span>
                                            </button>
                                        </li>

                                        <li className="nav-item">
                                            <button
                                                onClick={() =>
                                                    this.filter("approved")
                                                }
                                                className={
                                                    this.state.filterItem ===
                                                    "approved"
                                                        ? `nav-link active`
                                                        : `nav-link`
                                                }
                                            >
                                                Approved{" "}
                                                <span className="badge badge-pill badge-soft-secondary">
                                                    {this.state.meta.approved}
                                                </span>
                                            </button>
                                        </li>
                                        <li className="nav-item">
                                            <button
                                                onClick={() =>
                                                    this.filter("rejected")
                                                }
                                                className={
                                                    this.state.filterItem ===
                                                    "rejected"
                                                        ? `nav-link active`
                                                        : `nav-link`
                                                }
                                            >
                                                Declined{" "}
                                                <span className="badge badge-pill badge-soft-secondary">
                                                    {this.state.meta.rejected}
                                                </span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    <div className="card-body">
                        <div className="table-responsive  mv-5 ">
                            <div
                                id="DataTable_wrapper"
                                className="dataTables_wrapper dt-bootstrap4 no-footer"
                            >
                                <table
                                    id="DataTable"
                                    className="table table-sm table-nowrap card-table dataTable no-footer"
                                    role="grid"
                                    aria-describedby="DataTable_info"
                                >
                                    <thead>
                                        <tr role="row">
                                            <th
                                                className="sorting"
                                                tabIndex="0"
                                                aria-controls="DataTable"
                                                rowSpan="1"
                                                colSpan="1"
                                            >
                                                Writer
                                            </th>

                                            <th
                                                className="sorting"
                                                tabIndex="0"
                                                aria-controls="DataTable"
                                                rowSpan="1"
                                                colSpan="1"
                                            >
                                                Posted
                                            </th>

                                            <th
                                                className="sorting_disabled"
                                                rowSpan="1"
                                                colSpan="1"
                                                style={{
                                                    width: "135px"
                                                }}
                                            >
                                                Options
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody className="list">
                                        {this.state.items.map((item, index) => {
                                            return (
                                                <List
                                                    getItem={this.clear}
                                                    item={item}
                                                    index={index}
                                                    key={index}
                                                ></List>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

WorkSpaceFreelancers.contextType = AppContext;
export default WorkSpaceFreelancers;



// WEBPACK FOOTER //
// ./src/components/employer/workSpace/WorkSpaceFreelancers.js